import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelHomeServiceOrder = async ({ id, cancellationReason }: { id: number; cancellationReason: string }) => {
  const response = await mutationExecute({
    variables: {
      id,
      cancellationReason,
    },
    mutation: graphql(`
      mutation CancelHomeServiceOrder($id: Float!, $cancellationReason: String!) {
        cancelHomeServiceOrder(id: $id, cancellationReason: $cancellationReason) {
          id
        }
      }
    `),
  });

  return response.data?.cancelHomeServiceOrder;
};
